/*
 * Copyright (C) 2022 Inera AB (http://www.inera.se)
 *
 * This file is part of sklintyg (https://github.com/sklintyg).
 *
 * sklintyg is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * sklintyg is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import IaColors from '../styles/iaColors'
import { DocIcon } from '../styles/iaSvgIcons'
import PageHeader from '../styles/PageHeader'
import DataExportActionBar from './DataExportActionBar'

const DataExportPageHeader = () => {
  return (
    <PageHeader
      header="Dataexport till Säker journalutlämning"
      subHeader="Här kan du skapa en dataexport som levereras till Säker journalutlämning. Administrerade exporter visas i tabellen."
      icon={<DocIcon color={IaColors.IA_COLOR_02} />}
      actionBar={<DataExportActionBar />}
    />
  )
}

export default DataExportPageHeader
